import { useEffect, useRef } from 'react';
import { useRouter } from 'next/router';
import { subscribeRouteChangeComplete } from './subscribeRouteChange';
import type { RouteChangeCompleteHandler } from './types';

/** Runs `handler` after a client-side navigation completes. */
export const useRouteChangeComplete = (
  handler: RouteChangeCompleteHandler,
  enabled = true,
): void => {
  const { events } = useRouter();
  const handlerRef = useRef(handler);
  handlerRef.current = handler;

  useEffect(() => {
    if (!enabled) {
      return undefined;
    }

    const wrapped: RouteChangeCompleteHandler = (url) => {
      handlerRef.current(url);
    };

    return subscribeRouteChangeComplete(events, wrapped);
  }, [events, enabled]);
};
